import React from "react";
import "./TitleL2.scss";

function TitleL2({ children = "Default Text" }) {
  return <div className="title__L2">{children}</div>;
}

export default TitleL2;
